var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4C11.8749 3.87502 11.7053 3.80481 11.5285 3.80481C11.3518 3.80481 11.1822 3.87502 11.0572 4L7.99988 7.05733L4.94255 4C4.81753 3.87502 4.64799 3.80481 4.47121 3.80481C4.29444 3.80481 4.1249 3.87502 3.99988 4C3.8749 4.12502 3.80469 4.29456 3.80469 4.47133C3.80469 4.64811 3.8749 4.81765 3.99988 4.94267L7.05721 8L3.99988 11.0573C3.8749 11.1824 3.80469 11.3519 3.80469 11.5287C3.80469 11.7054 3.8749 11.875 3.99988 12C4.1249 12.125 4.29444 12.1952 4.47121 12.1952C4.64799 12.1952 4.81753 12.125 4.94255 12L7.99988 8.94267L11.0572 12C11.1822 12.125 11.3518 12.1952 11.5285 12.1952C11.7053 12.1952 11.8749 12.125 11.9999 12C12.1249 11.875 12.1951 11.7054 12.1951 11.5287C12.1951 11.3519 12.1249 11.1824 11.9999 11.0573L8.94254 8L11.9999 4.94267C12.1249 4.81765 12.1951 4.64811 12.1951 4.47133C12.1951 4.29456 12.1249 4.12502 11.9999 4Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/closeBlack.a85d9bedce2ebe7b7444892414610b6f.svg";
export { ForwardRef as ReactComponent };